(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider')) {
    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hero-slider__track');
        this.slides = Array.from(this.querySelectorAll('.hero-slide'));
        this.blurSlides = Array.from(
          this.closest('.hero')?.querySelectorAll('.hero-blur-slide') || []
        );
        this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
        this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
        this.nextBtn = this.querySelector('.hero-slider__arrow--next');

        this.transition = this.dataset.transition || 'fade';
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.current = 0;
        this.timer = null;

        if (this.slides.length <= 1) return;

        this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
        this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () =>
            this.go(parseInt(dot.dataset.slideIndex, 10))
          );
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.setupSwipe();

        const prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;
        if (this.autoplay && !prefersReducedMotion) this.start();
      }

      go(index) {
        const count = this.slides.length;
        this.current = (index + count) % count;
        this.render();
      }

      render() {
        this.slides.forEach((slide, i) => {
          const active = i === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) {
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('inert', '');
          }
          const link = slide.querySelector('.hero-slide__link');
          if (link) link.tabIndex = active ? 0 : -1;
        });

        this.blurSlides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.current);
        });

        this.dots.forEach((dot, i) => {
          const active = i === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (this.transition === 'slide' && this.track) {
          this.track.style.transform = `translateX(-${this.current * 100}%)`;
        }
      }

      start() {
        if (!this.autoplay || this.slides.length <= 1) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      setupSwipe() {
        let startX = 0;
        let dragging = false;
        this.track?.addEventListener(
          'touchstart',
          (e) => {
            startX = e.touches[0].clientX;
            dragging = true;
            this.stop();
          },
          { passive: true }
        );
        this.track?.addEventListener(
          'touchend',
          (e) => {
            if (!dragging) return;
            dragging = false;
            const diff = e.changedTouches[0].clientX - startX;
            if (Math.abs(diff) > 40) {
              this.go(diff < 0 ? this.current + 1 : this.current - 1);
            }
            this.start();
          },
          { passive: true }
        );
      }
    }

    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
          document.querySelectorAll('.testimonial-item').forEach((item) => {
          const video = item.querySelector('video');
          const button = item.querySelector('.play-pause-button');
          const playState = button?.querySelector('.play-state');
          const pauseState = button?.querySelector('.pause-state');
          const iconWrapper = button?.querySelector('.icon-wrapper');

          if (!video || !button) return;
          iconWrapper?.setAttribute('title', 'Pause');

          button.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              iconWrapper?.setAttribute('title', 'Pause');
              playState.removeAttribute('hidden');
              pauseState.setAttribute('hidden', '');
            } else {
              video.pause();
              iconWrapper?.setAttribute('title', 'Play');
              pauseState.removeAttribute('hidden');
              playState.setAttribute('hidden', '');
            }
          });
        });
      
  } catch(e) { console.error(e); }
})();
})();
